import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Link } from 'modules/UI';

import { Content, SeeMore } from './styles';

type PropTypes = {
  href?: string;
};

const LinkCard: React.FC<PropTypes> = ({ children, href }) => (
  <Link href={href} dataTestId="link-card">
    <Content>
      <div>{children}</div>
      <FormattedMessage id="know-more">{(content): JSX.Element => <SeeMore>{content}</SeeMore>}</FormattedMessage>
    </Content>
  </Link>
);

export default LinkCard;
